import React from 'react';
import { Card, CardContent, CardHeader } from '../ui/Card';
import { AssetDownloadGrid } from './AssetDownloadGrid';
import { ProfileCardHeader } from '../profile-sections/ProfileCardHeader';
import { BusinessProfileSection } from '../profile-sections/BusinessProfileSection';
import { ServicePackageSection } from '../profile-sections/ServicePackageSection';
import { OperationsSection } from '../profile-sections/OperationsSection';
import { AnalysisQueuedSection } from '../profile-sections/AnalysisQueuedSection';
import { ProfileCardActions } from '../profile-sections/ProfileCardActions';
import { IntelligenceProfile } from '../../types';

// Simplified interface - removed complex progress tracking properties

interface ProfileListItemProps {
  profile: IntelligenceProfile;
  executingOrchestrator: string | null;
  onExecuteOrchestrator: (profile: IntelligenceProfile) => void;
  onReprocessAnalysis?: (profile: IntelligenceProfile) => void;
  className?: string;
}

export const ProfileListItem: React.FC<ProfileListItemProps> = ({
  profile,
  executingOrchestrator,
  onExecuteOrchestrator,
  onReprocessAnalysis,
  className
}) => {
  return (
    <Card className={`mb-8 p-6 bg-gradient-to-r from-white to-blue-50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-l-8 border-l-blue-500 hover:border-l-blue-600 ${className || ''}`}>
      <CardHeader className="pb-4">
        <ProfileCardHeader profile={profile} />
      </CardHeader>
      
      <CardContent className="pt-2">
        <div className="space-y-4">
          {/* Business Profile Section */}
          <BusinessProfileSection profile={profile} />

          {/* Service Package Section */}
          <ServicePackageSection profile={profile} />

          {/* Operations Section */}
          <OperationsSection profile={profile} />

          {/* Analysis Status Section */}
          <AnalysisQueuedSection profile={profile} />

          {/* Assets Section */}
          {profile.submission?.assets && profile.submission.assets.length > 0 && (
            <AssetDownloadGrid assets={profile.submission.assets} />
          )}
        </div>

        {/* Action Buttons */}
        <ProfileCardActions
          profile={profile}
          executingOrchestrator={executingOrchestrator}
          isProfileProcessing={() => false} // Simplified - no more complex processing state
          onExecuteOrchestrator={onExecuteOrchestrator}
          onReprocessAnalysis={onReprocessAnalysis}
        />
      </CardContent>
    </Card>
  );
};